__turbopack_context__.v({
  "mobileOnly": "os53iq_mobileOnly",
});
